import React, { useEffect, useState } from 'react';
import { getSystemHealth } from '../../services/BeholderService';

const STATUS_COLORS = {
    green:  { bg: 'bg-success',  label: 'OK' },
    yellow: { bg: 'bg-warning',  label: 'Atenção' },
    red:    { bg: 'bg-danger',   label: 'Crítico' }
};

function fmtUptime(sec) {
    if (!sec) return '—';
    const d = Math.floor(sec / 86400);
    const h = Math.floor((sec % 86400) / 3600);
    if (d > 0) return `${d}d ${h}h`;
    const m = Math.floor((sec % 3600) / 60);
    if (h > 0) return `${h}h ${m}m`;
    return `${m}m`;
}

/**
 * Espelha o componente do frontend — mesma API GET /beholder/health.
 * Útil pro admin enxergar burst credit do E2.1.Micro acabando sem aviso.
 */
function SystemHealthIndicator() {
    const [health, setHealth] = useState(null);

    useEffect(() => {
        let alive = true;
        function load() {
            getSystemHealth()
                .then(h => { if (alive) setHealth(h); })
                .catch(() => {});
        }
        load();
        const id = setInterval(load, 30000);
        return () => { alive = false; clearInterval(id); };
    }, []);

    if (!health) return null;

    const status = STATUS_COLORS[health.status] || STATUS_COLORS.green;
    const tooltip = [
        `Status: ${status.label}`,
        `CPU: ${health.load1Pct}% (load ${health.load1} / ${health.cpuCount} core${health.cpuCount > 1 ? 's' : ''})`,
        `RAM: ${health.memPct}% (${health.memFreeMB}MB livres de ${health.memTotalMB}MB)`,
        `Node RSS: ${health.nodeRssMB}MB`,
        `Uptime: ${fmtUptime(health.uptimeSec)}`
    ].join('\n');

    return (
        <li className='nav-item mt-3 mb-2 text-center' title={tooltip}>
            <small className='sidebar-text d-block text-muted' style={{ fontSize: 10, lineHeight: 1.2 }}>
                <span
                    className={`d-inline-block rounded-circle ${status.bg} me-1`}
                    style={{ width: 8, height: 8 }}
                />
                Servidor: CPU {health.load1Pct}% · RAM {health.memPct}%
                <span className='d-block text-muted mt-1' style={{ fontSize: 9 }}>
                    {fmtUptime(health.uptimeSec)} no ar
                </span>
            </small>
        </li>
    );
}

export default SystemHealthIndicator;
